import { FetchResult, gql } from 'apollo-boost';
import { removeFields } from '../../../helpers/common-helpers';
import { IBelief } from '../../../models/belief';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query GetBelief($uid: String!){
        belief(uid: $uid) {
            uid,
            description,
            createdAt: created_at,
            updatedAt: updated_at,

            createdBy: created_by {
                uid,
                firstName: first_name,
                lastName: last_name,
            },

            updatedBy: updated_by {
                uid,
                firstName: first_name,
                lastName: last_name,
            },

            appraisal {
                uid,
            },

            owner {
                uid,
            },

            nonOwner: non_owner {
                uid,
            },
        }
    }
`;

export async function getBelief(uid: string): Promise<IBelief> {
    const result: FetchResult<{ belief: IBelief }> = await graphqlClient.query({
        query: QUERY,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return removeFields(result.data.belief, ['__typename']);
}
